module.exports = __webpack_public_path__ + "img/5.ea20e235.png";